import React, { FC } from 'react';
import { IconPencil } from '../../Icons';

interface Props {
  setShow: (show: boolean) => void;
  tipoForm: string;
  tipo?: string;
  setTipo?: (tipo: string) => void;
}
const ModalForm: FC<Props> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { setShow, tipo, setTipo, tipoForm } = props;

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <a
        onClick={() => {
          setShow(true);
          document.body.classList.add('fix');
          if (setTipo) {
            setTipo(tipoForm);
          }
        }}
        className="bloque-datos__action edit-datos"
      >
        <div className="icon icon__stroke icon-round">
          <IconPencil />
        </div>
      </a>
    </>
  );
};

export default ModalForm;
